export const ROLE_SUPERUSER = 1;
export const ROLE_ADMIN = 2;
export const ROLE_STRAFAMT = 3;
export const ROLE_ORGAN = 4;
export const ROLE_FINANZEN = 5;
export const ROLE_VERWALTUNG = 6;

export const ROLES: { id: number; name: string }[] = [
  { id: ROLE_SUPERUSER, name: 'Superuser' },
  { id: ROLE_ADMIN, name: 'Admin' },
  { id: ROLE_STRAFAMT, name: 'Strafamt' },
  { id: ROLE_ORGAN, name: 'Organ' },
  { id: ROLE_FINANZEN, name: 'Finanzen' },
  { id: ROLE_VERWALTUNG, name: 'Verwaltung' },
];

export const MODULES: { id: string; label: string }[] = [
  { id: 'transfer', label: 'Transfer' },
  { id: 'mandate', label: 'Mandate' },
  { id: 'zahlungsabgleich', label: 'Zahlungsabgleich' },
  { id: 'vstv', label: 'VSTV' },
  { id: 'reports', label: 'Reports' },
  { id: 'bulk-import', label: 'Bulk-Import' },
  { id: 'mobile', label: 'Mobile' },
];

export const MODULE_ENV_FLAGS: Record<string, 'showZahlungsabgleich' | 'showBulkImport' | null> = {
  transfer: null,
  mandate: null,
  zahlungsabgleich: 'showZahlungsabgleich',
  vstv: null,
  reports: null,
  'bulk-import': 'showBulkImport',
  mobile: null,
};

export function roleName(roleId: number): string {
  return ROLES.find((r) => r.id === roleId)?.name ?? 'Unbekannt';
}

/** Badge label + Tailwind classes per role (nav, Dienstnehmer table, etc.) */
export const ROLE_BADGES: Record<number, { label: string; classes: string }> = {
  [ROLE_SUPERUSER]: { label: 'Superuser', classes: 'bg-purple-100 text-purple-800' },
  [ROLE_ADMIN]: { label: 'Admin', classes: 'bg-indigo-100 text-indigo-800' },
  [ROLE_STRAFAMT]: { label: 'Strafamt', classes: 'bg-rose-100 text-rose-800' },
  [ROLE_ORGAN]: { label: 'Organ', classes: 'bg-sky-100 text-sky-800' },
  [ROLE_FINANZEN]: { label: 'Finanzen', classes: 'bg-amber-100 text-amber-800' },
  [ROLE_VERWALTUNG]: { label: 'Verwaltung', classes: 'bg-green-100 text-green-800' },
};

export function roleBadgeLabel(roleId: number): string {
  return ROLE_BADGES[roleId]?.label ?? roleName(roleId);
}

export function roleBadgeClasses(roleId: number): string {
  return ROLE_BADGES[roleId]?.classes ?? 'bg-gray-100 text-gray-700';
}

/** Client-side fallback when /role-permissions is unavailable */
export function buildDefaultRolePermissionMatrix(): {
  roles: { id: number; name: string }[];
  modules: { id: string; label: string }[];
  matrix: { [roleId: number]: { [module: string]: boolean } };
} {
  const matrix: { [roleId: number]: { [module: string]: boolean } } = {};
  for (const role of ROLES) {
    matrix[role.id] = {};
    for (const mod of MODULES) {
      matrix[role.id][mod.id] = role.id === ROLE_SUPERUSER || role.id === ROLE_ADMIN;
    }
  }
  return {
    roles: ROLES.map((r) => ({ id: r.id, name: r.name })),
    modules: MODULES.map((m) => ({ ...m })),
    matrix,
  };
}
